import {
  Elements,
  PaymentMethodMessagingElement,
} from '@stripe/react-stripe-js';
import { Stripe, loadStripe } from '@stripe/stripe-js';
import React, { useEffect, useState } from 'react';
import { stripePublicKey } from 'utils/helpers/paymentHelpers';

export type StripeMerchandisingWidgetProps = {
  // Value in cents
  amount: number;
  fontSizeBase?: string;
};

/**
 * Renders Stripe's Payment Method Messaging Element.
 * The Payment Method Messaging Element is a UI component for informing a customer about available buy-now-pay-later plans.
 */
const StripeMerchandisingWidget = (props: StripeMerchandisingWidgetProps) => {
  const [stripePromise, setStripePromise] =
    useState<Promise<Stripe | null> | null>(null);

  const { amount, fontSizeBase } = props;

  useEffect(() => {
    if (!stripePromise) {
      setStripePromise(loadStripe(stripePublicKey));
    }
  }, [stripePromise]);

  // customize appearance for PaymentMethodMessagingElement

  const appearance = {
    variables: {
      fontSizeBase: fontSizeBase || '14px',
    },
    rules: {
      '.PaymentMethodMessaging': {
        textAlign: 'center',
      },
    },
  };

  // Amount is already in cents, rounding it to the nearest whole number
  const roundedAmount = Math.round(amount);

  return (
    <Elements stripe={stripePromise} options={{ appearance }}>
      <PaymentMethodMessagingElement
        options={{
          amount: roundedAmount,
          currency: 'USD',
          countryCode: 'US',
          paymentMethodTypes: ['klarna', 'affirm', 'afterpay_clearpay'],
        }}
      />
    </Elements>
  );
};

export default StripeMerchandisingWidget;
